import { toCurrency, toPoints} from '@/shared/helpers'
export const TABLE_COLUMNS = [
  {
    Header: "Redemption Date",
    accessor: "redemption_date",
  },
  {
    Header: "Program Name",
    accessor: "program_name",
  },
  {
    Header: "Merchant Name",
    accessor: "merchant_name",
  },
  {
    Header: "First Name",
    accessor: "first_name",
  },
  {
    Header: "Last Name",
    accessor: "last_name",
  },
  {
    Header: "Email",
    accessor: "u_email",
  },
  {
    Header: "Points Redeemed",
    accessor: "redemption_points",
    Cell: ({ row, value }) => { return toPoints(value) },
  },
  {
    Header: "Dollar Amount",
    accessor: "redemption_value",
    Cell: ({ row, value }) => { return toCurrency(value) },
  },
];
